module.exports = __webpack_public_path__ + "officialStatic/img/astronaut2.a0cad9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/astronaut2.png
// module id = 9/l4
// module chunks = 0